import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { purchaseAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { ClipboardList, Clock, CheckCircle, FileText, Truck, Package, AlertCircle } from 'lucide-react';

export default function PurchaseDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await purchaseAPI.dashboard();
        setStats(res.data);
      } catch { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64 text-sm text-muted-foreground">Loading...</div>;

  const cards = [
    { label: 'Items in Indent', value: stats?.indent_count || 0, icon: ClipboardList, color: 'border-l-cyan-500', path: '/purchase/indent' },
    { label: 'Pending Quotes', value: stats?.pending_quote_count || 0, icon: Clock, color: 'border-l-amber-500', path: '/purchase/indent?status=pending_quote' },
    { label: 'PRs Pending', value: stats?.purchase_request_count || 0, icon: AlertCircle, color: 'border-l-red-500', path: '/purchase/requests?status=pending_approval' },
    { label: 'Approved PRs', value: stats?.approved_pr_count || 0, icon: CheckCircle, color: 'border-l-emerald-500', path: '/purchase/requests?status=approved' },
    { label: 'PO Generated', value: stats?.po_generated_count || 0, icon: Package, color: 'border-l-blue-500', path: '/purchase/requests?status=po_generated' },
    { label: 'POs Sent', value: stats?.po_sent_count || 0, icon: Truck, color: 'border-l-purple-500', path: '/purchase/requests?status=po_sent' },
    { label: 'Partially Received', value: stats?.partially_received_count || 0, icon: FileText, color: 'border-l-orange-500', path: '/purchase/requests?status=partially_received' },
  ];

  return (
    <div className="space-y-6" data-testid="purchase-dashboard">
      <div>
        <h1 className="font-heading text-xl font-bold tracking-tight">Purchase Dashboard</h1>
        <p className="text-xs text-muted-foreground mt-1">Overview of purchasing activities</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(c => (
          <Card key={c.label} className={`border-l-4 ${c.color} cursor-pointer hover:shadow-md transition-shadow`}
            onClick={() => navigate(c.path)} data-testid={`dash-card-${c.label.toLowerCase().replace(/\s+/g, '-')}`}>
            <CardContent className="pt-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] text-slate-500 font-medium tracking-wide">{c.label.toUpperCase()}</p>
                  <p className="text-2xl font-bold text-[#0F172A] mt-1">{c.value}</p>
                </div>
                <c.icon className="w-7 h-7 text-slate-200" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
